import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import List from './components/List'

// Authorization routes nested under Settings (/settings/authorization/*)
const AuthorizationRoutes: RouteObject = {
    path: 'authorization',
    children: [
        {
            path: '',
            element: <List />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default AuthorizationRoutes
